import React from "react";
import { Link } from "react-router-dom";

const RouterLink = ({ link, className, onClick, children, style, ...rest }) => (
  <Link
    to={link}
    className={className}
    style={style}
    onClick={onClick}
    data-testid={rest["data-testid"]}
  >
    {children}
  </Link>
);

export default RouterLink;
